import styled, { css } from "styled-components";

export const Wrapper = styled.div`
	/* margin-bottom: 2rem; */
	gap: 2rem;
	display: flex;
	flex-direction: column;
`;

export const FortnoxRowWrapper = styled.div<{ plain?: boolean }>`
	/* binvoice-bottom: 1px solid #dfe3e8; */
	display: flex;
	gap: 0.5rem;
	--p-text-disabled: var(--textColor);

	display: grid;
	grid-template-columns: minmax(75px, 250px) minmax(200px, auto) 100px 100px 150px 150px 50px;

	& > *:not(:last-child) {
		flex: 1;
	}

	input {
		font-size: 14px;
	}

	.Polaris-TextField__Prefix {
		.Polaris-Icon {
			height: 1.75rem;
			width: 1.75rem;
		}
	}

	.dropdown {
		opacity: 0.75;
		transition: opacity 250ms ease-in-out;

		&:hover {
			opacity: 1;
		}
	}

	${({ plain }) =>
		plain &&
		css`
			--p-text-disabled: "var(--textColor)";

			.Polaris-TextField {
				opacity: 1;
				/* -webkit-text-fill-color: var(--textColor); */
			}

			.Polaris-TextField__Backdrop {
				background: transparent !important;
			}

			.Polaris-TextField__Prefix {
				display: none;
			}

			* {
				box-shadow: none !important;
			}
		`};
`;

export const InfoWrapper = styled.div`
	--p-border-radius-base: 6px;
	--p-text-disabled: var(--textColor);

	.Polaris-Button {
		&,
		* {
			transition-property: background-color, color, box-shadow, filter;
			transition-duration: 250ms;
		}
	}

	[data-buttongroup-segmented="true"] > :first-child .Polaris-Button {
		border-top-left-radius: 6px;
		border-bottom-left-radius: 6px;
	}

	[data-buttongroup-segmented="true"] > :last-child .Polaris-Button {
		border-top-right-radius: 6px;
		border-bottom-right-radius: 6px;
	}
`;

export const ColumnHeader = styled.div`
	flex: 1;
	margin-left: 5px;
`;
export const ColumnHeaderWrapper = styled.div`
	display: flex;
	font-weight: bold;
	gap: 0.5rem;

	display: grid;
	grid-template-columns: minmax(100px, 400px) auto 100px 100px 150px 150px 50px;
`;
